import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { WALLET_TYPE } from '../../proptype/walletProp';
import CoinsIcon from './CoinsIcon';

export default function NetworkListItem({ network, selected, onSelect }) {
  const handleClick = useCallback(selected ? undefined : onSelect, [
    selected,
    onSelect,
  ]);

  return (
    <button type="button" className="network-item" onClick={handleClick}>
      <div className={`network-item-radio ${selected ? 'selected' : ''}`} />
      {network.type === WALLET_TYPE.FIAT ? (
        <CoinsIcon />
      ) : (
        <img src={network.currencyInfo?.icon} alt="crypto logo" />
      )}
      {network.name}
    </button>
  );
}

NetworkListItem.propTypes = {
  network: PropTypes.shape({
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    currencyInfo: PropTypes.shape({
      icon: PropTypes.string,
    }),
  }).isRequired,
  selected: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
};
